import { Trans } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  code: {
    marginRight: Spacing.M,
  },
})

interface Props extends ViewProps {}

const UnauthorizedScreen = (props: Props) => {
  const { style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text level={1} style={styles.code}>
        401
      </Text>
      <Text>
        <Trans>Unauthorized</Trans>
      </Text>
    </View>
  )
}

export default UnauthorizedScreen
